module.exports = __webpack_public_path__ + "static/media/ev-jea-logo.de4692e7.svg";